import {
  Card
} from 'antd';

const SelectedDateCard = ({ label, value }) => {
  return (
    <Card
      style={{
        width: '100%',
        height: '100%'
      }}
    >
      <p
        style={{
          fontSize: '0.6rem',
          color: '#555',
          textTransform: 'capitalize'
        }}
      >
        {label}
      </p>
      <p
        style={{
          fontSize: '0.8rem',
          fontWeight: 'bold',
        }}
      >
        {value.format('DD-MMM-YYYY')}
      </p>
    </Card>
  );
};

export default SelectedDateCard;
